<template>
  <div
    class="atlas-loading"
    :style="style" />
</template>

<script>
export default {
  name: 'AtlasLoading',
  props: {
    size: {
      type: Number,
      default: 50
    }
  },
  computed: {
    style () {
      const size = this.size + 'px'
      return { width: size, height: size }
    }
  }
}
</script>

<style lang="scss">
.atlas-loading {
  display: inline-block;
  background: url('./loading.gif');
  background-position: center center;
  background-size: cover;
  border-radius: 50%;
  line-height: 0;
  margin: 0;
}
</style>
